import React from "react";
import { Dialog, Flex, Text, TextField, Button } from "@radix-ui/themes";
import { ArrowTopRightOnSquareIcon } from "@heroicons/react/24/solid";

export function AuthBrevoDialog({
  isOpen,
  onOpenChange,
  onCancel,
  onSave,
  handleApiKeyChange,
  isApiKeyValid,
  isLoading,
  title = "Connect Brevo",
}) {
  return (
    <Dialog.Root open={isOpen} onOpenChange={onOpenChange}>
      <Dialog.Content maxWidth="600px" maxHeight="690px" align="center">
        <Dialog.Title>{title}</Dialog.Title>
        <Dialog.Description size="2" mb="4">
          To find your API key, log into Brevo and go to Settings → SMTP & API → API Keys & MCP to copy or create one. This integration only utilizes an API Key, not an MCP key.
          See Brevo's documentation for further details.
        </Dialog.Description>

        <Flex
          direction="column"
          gap="2"
          p="3"
          style={{
            backgroundColor: "var(--accent-a3)",
            borderRadius: "var(--radius-3)",
            border: "1px solid var(--accent-a5)",
          }}
        >
          <Text size="2" weight="medium" color="accent">
            Custom Attributes
          </Text>
          <Text size="2" color="gray">
            We will automatically create three custom attributes in your Brevo account: <strong>GENDER</strong>, <strong>BIRTHDAY</strong>, and <strong>AGE_GROUP</strong>. 
            These attributes allow us to sync additional customer data beyond basic contact information (email, first name, last name, and SMS). 
            You can delete these attributes from your Brevo account at any time if you no longer need them.
          </Text>
        </Flex>

        <Flex className="slot-container" style={{ paddingTop:"14px", alignSelf: "stretch" }} display="flex" direction="row" align="start" gap="5">
          <Flex className="api-key-field" style={{ flex: 1 }} display="flex" direction="column" align="start" gap="1">
            <Text size="2" weight="medium">
              API key
            </Text>
            <TextField.Root
              onChange={handleApiKeyChange}
              placeholder="Paste your Brevo API key here"
              style={{ width: "100%" }}
              size="2"
              variant="surface"
            />
            {!isApiKeyValid && (
              <Text size="1" weight="regular" color="red">
                Please enter a valid API key.
              </Text>
            )}
          </Flex>
        </Flex>

        <Flex
          style={{
            alignSelf: "stretch",
            width: "100%",
          }}
          display="flex"
          justify="between"
          align="center"
          mt="4"
        >
          <Button
            size="2"
            variant="ghost"
            color="gray"
            onClick={() => window.open("https://app.brevo.com/settings/keys/api", "_blank")}
          >
            <Flex display="flex" align="center" gap="2">
              Open Brevo API Page
              <ArrowTopRightOnSquareIcon style={{ width: "16px", height: "16px" }} />
            </Flex>
          </Button>

          <Flex display="flex" gap="3" justify="end">
            <Dialog.Close>
              <Button onClick={onCancel} size="2" variant="soft" color="gray">
                Cancel
              </Button>
            </Dialog.Close>
            <Button onClick={() => onSave()} size="2" variant="soft" color="accent" loading={isLoading}>
              Save and continue
            </Button>
          </Flex>
        </Flex>
      </Dialog.Content>
    </Dialog.Root>
  );
}
